import { IQueryBuilder, QueryBuilder } from '../builders/query-builder';
import { IServiceFactory } from '../types/service-factory';

export class QueryBuilderFactory implements IServiceFactory<IQueryBuilder> {
	public Create(): IQueryBuilder {
		return new QueryBuilder();
	}
}
